import { useTranslation } from 'react-i18next'

import { StatusPill } from '@/components/px/StatusPill'

/**
 * LOCKED — marks a surface or element demoing an aspirational feature not in
 * the validated UI (design-prototype hard rule 5). Never remove to make a
 * walkthrough look more finished.
 *
 * PX-W6.6 moved its label into the `common` locale namespace (spec D1): the
 * badge is PRODUCT furniture rendered on concept surfaces, so its two words are
 * the one piece of copy on those screens that must exist in EN and NL.
 */
export function ConceptBadge() {
  const { t } = useTranslation('common')
  return <StatusPill tone="review">{t('concept.badge.label')}</StatusPill>
}
